module.exports = __webpack_public_path__ + "static/media/28DGC2.2c3e91a5.jpg";